import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import locations from 'modules/locations/store/collections/locations'

interface LocationMultiselectorProps {
  locationIds: number[] | null | undefined
  form: Form
}

const LocationMultiselector = ({ locationIds, form }: LocationMultiselectorProps) => {
  const [locationsIds, setLocationsIds] = React.useState(locationIds ?? [])

  React.useEffect(() => {
    if (locationIds) {
      setLocationsIds(locationIds)
    }
  }, [locationIds])
  const handleChangeLocations = (ids: number[]) => {
    setLocationsIds(ids)

    form.get('location_ids').set(ids)
  }

  const locationOptions = locations.map((x) => {
    const { id, name } = x.attributes

    return (
      <Selector.Option key={id} value={id} label={name} searchValue={name}>
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium">
            {name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={i18n.t('settings.permissions.visibility.choices.dynamic_group_options.location')}
      blankLabel={i18n.t('common.empty')}
      allSelectedLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      searchPlaceholder={i18n.t('common.search')}
      icon="office"
      value={locationsIds ? locationsIds : []}
      onChange={(ids) => handleChangeLocations(ids as number[])}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
      maxHeight="s400"
    >
      {locationOptions}
    </Selector.Popover>
  )
}
export default observer(LocationMultiselector)
